import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
// import CyberComponent from "containers/CyberComponent";
import { Form } from "react-bootstrap";
import RequestControls from "containers/request/RequestControls";
import Instructions from "containers/request/OTA/OTADeviceInfoBubble";
import RequestManufacturer from "components/request/RequestManufacturer";
import RequestDescChanges from "components/request/RequestDescChanges";
import BatteryParentDetails from "components/request/BatteryParentDetails";
import RequestEcoModelPRR from "containers/request/PRR/RequestEcoModelPRR";
import RequestVoltage from "components/request/RequestVoltage";
import RequestRevision from "components/request/RequestRevision";
import NonSarSites from "containers/request/battery/NonSarSites/NonSarSites";
import NonSarSitesReadonly from "containers/request/battery/NonSarSites/NonSarSitesReadonly";
import PackCells from "containers/request/battery/PackCellsWithRecognition/PackCellsWithRecognition";
import PackCellsReadonly from "components/request/PackCellsReadonly";
import SubmissionDetails from "containers/request/RequestContent/SubmissionDetails";
import RequestParentLink from "components/request/RequestParentLink";
import { setValue, setBatteryRequestPermissions } from "actions/request";
import { initEcoPRR, updateDeviceInfoPRR } from "actions/battery/prrRequest";
import { mapNonSarManufSites } from "actions/battery/batteryRequests";
import { submitWizardStep } from "actions/wizard";
import { hasStringValue } from "helpers/RequestHelper";
import { getRequestOwner } from "helpers/UsersHelper";

class RequestECOContainerPRR extends React.Component {
  modelField = this.props.request.id ? "modelName" : "existedModel";

  componentDidMount() {
    const { request, user } = this.props;
    const ownerId = getRequestOwner(request, user);

    // fetch only for the first time on submissions
    if (!this.validate() && !request.id) {
      this.props.initEcoPRR(request.ieee, ownerId);
    }

    // fetch for existed requests
    // if (request.id) {
    //   const companyid = user.isStaff ? request.submitter.companyid : null;

    //   this.props
    //     .initEcoPRR(request.ieee, companyid)
    //     .then(() => this.props.mapNonSarManufSites(request.linkedManufsites));
    // }

    // set permissions for existed request
    this.props.setBatteryRequestPermissions(request, user);
  }

  onSaveClick = () => {
    this.props.updateDeviceInfoPRR(
      this.props.request,
      this.props.sites.nonSarSites
    );
  };

  validateModel() {
    return hasStringValue(this.props.request, this.modelField);
  }

  validateRevision() {
    return hasStringValue(this.props.request, "revision");
  }

  validateDesc() {
    return hasStringValue(this.props.request, "descriptionOfChange");
  }

  validateManufSites() {
    const { sites } = this.props;

    return sites && sites.nonSarSites && _.some(sites.nonSarSites, "checked");
  }

  validatePackCells() {
    const { request } = this.props;

    return request.cellSuppliers && request.cellSuppliers.length > 0;
  }

  validate() {
    // don't need to validate if form is non-editable
    if (this.props.user.canEditDeviceInfo === false) return true;

    // check if all required fields are valid
    return (
      this.validateModel() &&
      this.validateRevision() &&
      this.validateManufSites() &&
      this.validateDesc() &&
      this.validatePackCells()
    );
  }

  render() {
    const { request, user } = this.props;
    const { canEditDeviceInfo } = user;
    const saveHandler = canEditDeviceInfo ? this.onSaveClick : null;

    return (
      <div>
        <Instructions />
        <Form horizontal>
          <RequestParentLink certPrefix="prr" />
          <BatteryParentDetails />
          <hr />
          <RequestManufacturer />
          <RequestEcoModelPRR />
          <hr />
          {/* TODO: use permission flag to manage editable state */}
          {request[this.modelField] && (
            <>
              <RequestRevision
                fieldId="revision"
                editable={canEditDeviceInfo}
              />
              <RequestDescChanges />
              <RequestVoltage
                fieldId="voltage"
                fieldLabel="Voltage (V)"
                editable={false}
              />
              <RequestVoltage
                fieldId="capacity"
                fieldLabel="Capacity (mAh)"
                editable={false}
              />
              <SubmissionDetails />
              <hr />
              {canEditDeviceInfo ? <NonSarSites /> : <NonSarSitesReadonly />}
              <hr />
              {canEditDeviceInfo ? <PackCells /> : <PackCellsReadonly />}
            </>
          )}
          <RequestControls isValid={this.validate()} onSave={saveHandler} />
        </Form>
      </div>
    );
  }
}

function mapStateToProps({ request, user, sites }) {
  return { request, user, sites };
}

export default connect(mapStateToProps, {
  initEcoPRR,
  submitWizardStep,
  updateDeviceInfoPRR,
  setValue,
  setBatteryRequestPermissions,
  mapNonSarManufSites
})(RequestECOContainerPRR);
